// @ts-nocheck
import { combineReducers } from "redux";
import { CreateOffenceDataType, FeedType, OffenceType } from "../../types";
import { FeedTypes } from "../../constants/offence";
import {
  RESET_CREATE_OFFENCE_DATA,
  RESET_FULL_VIDEO_OFFENCE,
  SET_CREATE_OFFENCE_DATA,
  SET_FEED,
  SET_FULL_VIDEO_OFFENCE,
  SET_THUMBNAIL,
  UPDATE_KEYS_IN_FEED,
} from "./types";

const initFeedData: { feedData: FeedType[]; page: number } = {
  feedData: [],
  page: 1,
};
const initCreateOffenceData: CreateOffenceDataType = null;
const initFullScreenOffenceData: OffenceType = null;

const feedData = (state = initFeedData, action) => {
  const { type, feedData, updateArgs, offence, page } = action;
  const stateCopy = JSON.parse(JSON.stringify(state));
  switch (type) {
    case SET_FEED:
      return { feedData, page };

    case UPDATE_KEYS_IN_FEED:
      stateCopy.feedData.forEach((e) => {
        if (
          e.componentType === FeedTypes.OffenceReport &&
          e?.offenceData?.uid === offence?.uid
        ) {
          updateArgs?.forEach((obj) => {
            if (obj?.key && obj?.value) {
              e.offenceData[obj.key] = obj?.value;
            }
          });
        }
      });
      return stateCopy;

    default:
      return state;
  }
};

const createOffenceData = (state = initCreateOffenceData, action) => {
  const { type, createOffenceData, thumbnail } = action;

  switch (type) {
    case SET_CREATE_OFFENCE_DATA:
      return createOffenceData;

    case RESET_CREATE_OFFENCE_DATA:
      return null;

    case SET_THUMBNAIL:
      return state
        ? { ...state, media: { ...state.media, thumbnail } }
        : { media: { thumbnail } };

    default:
      return state;
  }
};

const fullScreenVideoOffence = (state = initFullScreenOffenceData, action) => {
  const { type, offence } = action;

  switch (type) {
    case SET_FULL_VIDEO_OFFENCE:
      return offence;

    case RESET_FULL_VIDEO_OFFENCE:
      return null;

    default:
      return state;
  }
};

export default function () {
  return combineReducers({
    feedData,
    createOffenceData,
    fullScreenVideoOffence,
  });
}
